<template>
  <section class="projection-preview-packages" data-projection-preview-region="packages">
    <SectionHeading icon="icon-travel-crossroad-direction-board" title="Available packages" />
    <PackageCard
      v-for="event in store.projectionPreviewPackageEvents"
      :key="event.id"
      :event="event"
      :itinerary="store.data.itinerary"
      readonly
      :show-availability="false"
    />
  </section>
</template>

<script setup lang="ts">
import { useItineraryStore } from '@/stores/itinerary.js'
import SectionHeading from '@/modules/Itinerary/Components/SectionHeading.vue'
import PackageCard from '@/modules/SelectPackage/PackageCard.vue'

const store = useItineraryStore()
</script>

<style scoped lang="scss">
.projection-preview-packages {
  display: grid;
  gap: $spacing-3;
}
</style>
